import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faBars,
  faPowerOff,
  faBell,
  faExclamationCircle,
  faThLarge,
  faUsers,
  faMoneyCheckAlt,
  faPiggyBank,
  faUserCog,
  faFileInvoiceDollar,
  faClock,
  faUser,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faAngleLeft,
  faAngleRight,
  faSearch,
  faCalendar,
  faPrint,
  faListAlt,
  faIdCardAlt,
  faIdBadge,
  faEye,
  faEyeSlash,
  faPencilAlt,
  faTrash,
  faSave,
  faTimesCircle,
  faSquareFull,
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faBars,
  faPowerOff,
  faBell,
  faExclamationCircle,
  faThLarge,
  faUsers,
  faMoneyCheckAlt,
  faPiggyBank,
  faUserCog,
  faFileInvoiceDollar,
  faClock,
  faUser,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faAngleLeft,
  faAngleRight,
  faSearch,
  faCalendar,
  faPrint,
  faListAlt,
  faIdBadge,
  faIdCardAlt,
  faEye,
  faEyeSlash,
  faPencilAlt,
  faTrash,
  faSave,
  faTimesCircle,
  faSquareFull
);

export default library;
